var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import "../MutualFundsStyleSheet/AllClientsTab.scss";
import TransferInImg from "@frameworks/arn-transfer/assets/transferIn.svg";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { EFilterValues, EScreenState, syncNowCheckBoxDetails, } from "@frameworks/arn-transfer/constants/constant";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { generateClientTierIcon } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import { Overlay, Popover } from "react-bootstrap";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import SidebarHeader from "../Sidebar/SidebarHeader";
import MFCentralSidebarBody from "../Sidebar/MFCentralSidebarBody";
import MFCentralSidebarFooter from "../Sidebar/MFCentralSidebarFooter";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import { getArnAllMoreClientTabDetails, } from "@frameworks/arn-transfer/api/ArnAllMoreClient";
import { ETransferInClientTabs } from "../MFTransfer";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import { getMfCenterOtp, } from "@frameworks/arn-transfer/api/MfCenterOtp";
import { getMfCenterData } from "@frameworks/arn-transfer/api/MfCenterData";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import { getArnFiltersData, } from "@frameworks/arn-transfer/api/ArnFilters";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
var AllClientsTab = function (props) {
    var _a = __read(useState({ isShowPopup: false, containerId: "", pan: "" }), 2), tableActionConfig = _a[0], setTableActionConfig = _a[1];
    var _b = __read(useState(""), 2), seletedCheckBox = _b[0], setSeletedCheckBox = _b[1];
    var _c = __read(useState(false), 2), openSidebar = _c[0], setOpenSidebar = _c[1];
    var _d = __read(useState(""), 2), mobileNumber = _d[0], setMobileNumber = _d[1];
    var _e = __read(useState(false), 2), isShowOtpField = _e[0], setIsShowOtpField = _e[1];
    var _f = __read(useState(false), 2), otpTimer = _f[0], setOtpTimer = _f[1];
    var _g = __read(useState(""), 2), otp = _g[0], setOtp = _g[1];
    var _h = __read(useState(""), 2), isOtpError = _h[0], setIsOtpError = _h[1];
    var _j = __read(useState(false), 2), isReadyToProceed = _j[0], setIsReadyToProceed = _j[1];
    var _k = __read(useState(false), 2), isShowFilterPopup = _k[0], setIsShowFilterPopup = _k[1];
    var _l = __read(useState(EScreenState.GENERATE_OTP), 2), currentScreen = _l[0], setCurrentScreen = _l[1];
    var _m = __read(useState(), 2), currentFilterState = _m[0], setCurrentFilterState = _m[1];
    var _o = __read(useState(), 2), finalFilterState = _o[0], setFinalFilterState = _o[1];
    var _p = __read(useState([]), 2), tableData = _p[0], setTableData = _p[1];
    var _q = __read(useState({ type: ESortOrder.DESCENDING, sortKey: "ac_name" }), 2), sortType = _q[0], setSortType = _q[1];
    var _r = __read(useState(), 2), clientInfoToBeSynced = _r[0], setClientInfoToBeSynced = _r[1];
    var _s = __read(useState(), 2), genereateOtpData = _s[0], setGenereateOtpData = _s[1];
    var _t = __read(useState(false), 2), sidebarBodyLoader = _t[0], setSidebarBodyLoader = _t[1];
    var _u = __read(useState(false), 2), inputDisabled = _u[0], setInputDisabled = _u[1];
    var _v = __read(useState(""), 2), mobileFieldError = _v[0], setMobileFieldError = _v[1];
    var _w = __read(useState(), 2), filterData = _w[0], setFilterData = _w[1];
    var _x = __read(useState(false), 2), tableLoader = _x[0], setTableLoader = _x[1];
    var _y = __read(useState(""), 2), searchText = _y[0], setSearchText = _y[1];
    var handleSyncNowClick = function (details) {
        setMobileNumber(details[1]);
        setClientInfoToBeSynced(function (prev) {
            var updatedData = {
                pan: details[0],
                mobileno: details[1],
                email: details[2],
                ucccode: details[3],
                ac_name: details[4],
                client_tier: details[5],
                ac_code: details[6],
                sync_id: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.id,
            };
            return updatedData;
        });
        setTableActionConfig(function (prev) {
            var updatedState = {
                isShowPopup: (prev === null || prev === void 0 ? void 0 : prev.containerId) === ""
                    ? true
                    : (prev === null || prev === void 0 ? void 0 : prev.containerId) === details[0] && (prev === null || prev === void 0 ? void 0 : prev.isShowPopup)
                        ? false
                        : true,
                containerId: details[0],
                pan: details[0],
            };
            return updatedState;
        });
    };
    var syncNowBtn = function (idx) {
        return (React.createElement("div", { id: idx[0], className: "sync-now-btn txt-tomato d-flex align-items-center DMSan_14_500 hand_cursor", onClick: function () {
                handleSyncNowClick(idx);
            } },
            React.createElement("span", { className: "me-2" }, "Sync Now"),
            React.createElement("span", { className: "bg_light-salmon-pink" }),
            React.createElement("span", { className: "ms-2 d-flex" }, (tableActionConfig === null || tableActionConfig === void 0 ? void 0 : tableActionConfig.isShowPopup) &&
                (tableActionConfig === null || tableActionConfig === void 0 ? void 0 : tableActionConfig.containerId) === idx[0] ? (React.createElement("i", { className: "edel-icon-arrow-up-thin" })) : (React.createElement("i", { className: "edel-icon-arrow-down" })))));
    };
    var allClientsTabColumn = [
        {
            columnName: "Client Name/PAN",
            sortKey: "ac_name",
            arrows: true,
            columnClassName: "",
            applySorting: true,
            keysForCustomFunction: ["ac_name", "pan", "client_tier"],
            tdCustomFunction: function (keys) {
                var _a;
                return (React.createElement(GenericSchemeName, { name: keys[0], subText1: keys[1], badgeIcon: generateClientTierIcon(keys[2]), showImage: true, parentClassName: (_a = keys[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase(), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, maxWidth: 305, showTooltip: true }));
            },
        },
        {
            columnName: "Investment with Nuvama (₹)",
            key: "inv_amt",
            sortKey: "inv_amt",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("span", { className: "RobotoM_14_500" }, key))); },
        },
        {
            columnName: "Actions",
            arrows: false,
            columnClassName: "text-end",
            applySorting: false,
            keysForCustomFunction: [
                "pan",
                "mobileno",
                "email",
                "ucccode",
                "ac_name",
                "client_tier",
                "ac_code",
            ],
            tdCustomFunction: function (keys) {
                return syncNowBtn(keys);
            },
        },
    ];
    var allClientFilterTabs = [
        {
            eventKey: "client_tier",
            title: "Client Tier",
            tabContent: generateClientTierFilterTabContent(),
        },
    ];
    function generateClientTierFilterTabContent() {
        var _a;
        return (React.createElement("div", { className: "client-tier-filters" }, (_a = filterData === null || filterData === void 0 ? void 0 : filterData.clientTier) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            var _a;
            return (React.createElement("div", { key: item.Id, className: "cursor-pointer", onClick: function () {
                    handleSetFilterState("clientTier", item);
                } },
                React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "cursor-pointer", checkboxProps: {
                        checked: !!((_a = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.clientTier) === null || _a === void 0 ? void 0 : _a.some(function (tierItem) { return tierItem.Id === (item === null || item === void 0 ? void 0 : item.Id); })),
                        value: item.Name,
                        name: "clientTier",
                    }, customLabel: React.createElement("label", { className: "client-tier-filter-label cursor-pointer" },
                        React.createElement("span", { className: "txt-han-blue DMSansNormal_12_400" }, item === null || item === void 0 ? void 0 : item.Name),
                        React.createElement("span", null,
                            React.createElement("img", { src: generateClientTierIcon(item === null || item === void 0 ? void 0 : item.Name), alt: item === null || item === void 0 ? void 0 : item.Name }))) })));
        })));
    }
    var handleSetFilterState = function (key, value) {
        setCurrentFilterState(function (prev) {
            var _a;
            var prevState = prev || {};
            var existingValues = prevState[key] || [];
            var exists = existingValues.some(function (v) { return v.Id === value.Id; });
            var updatedValues = exists
                ? existingValues.filter(function (v) { return v.Id !== value.Id; })
                : __spreadArray(__spreadArray([], __read(existingValues), false), [value], false);
            return __assign(__assign({}, prevState), (_a = {}, _a[key] = updatedValues, _a));
        });
    };
    var handleCallbackSort = function (e) {
        getAllClientTableData({ orderby: e.sortKey, orderbydesc: !e.type });
        setSortType(function () { return ({
            type: e.type ? ESortOrder.ASCENDING : ESortOrder.DESCENDING,
            sortKey: e.sortKey,
        }); });
    };
    var getAllClientTableData = function (params) {
        var _a, _b, _c, _d;
        setTableLoader(true);
        var payload = {
            searchValue: (_a = params === null || params === void 0 ? void 0 : params.searchValue) !== null && _a !== void 0 ? _a : searchText,
            tabId: Number(ETransferInClientTabs.ALL_CLIENTS),
            clientTierId: (params === null || params === void 0 ? void 0 : params.clientTierId)
                ? params === null || params === void 0 ? void 0 : params.clientTierId
                : ((_c = (_b = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.clientTier) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.Id; })) === null || _c === void 0 ? void 0 : _c.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
            sync_id: 0,
            uccCode: "",
            page_index: 1,
            page_size: 100,
            orderbydesc: !!(params === null || params === void 0 ? void 0 : params.orderbydesc),
            orderby: (_d = params === null || params === void 0 ? void 0 : params.orderby) !== null && _d !== void 0 ? _d : "",
        };
        getArnAllMoreClientTabDetails(payload)
            .then(function (resp) {
            setTableData(resp === null || resp === void 0 ? void 0 : resp.data);
            setTableLoader(false);
        })
            .catch(function (err) {
            setTableLoader(false);
        });
    };
    var getMfCenterOtpData = function () {
        setSidebarBodyLoader(true);
        getMfCenterOtp({
            email: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.email,
            mobile: mobileNumber,
            pan: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.pan,
            syncId: 0,
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
        })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                setGenereateOtpData(resp === null || resp === void 0 ? void 0 : resp.data);
                setIsShowOtpField(true);
                setOtpTimer(true);
                setMobileFieldError("");
                setInputDisabled(true);
            }
            setSidebarBodyLoader(false);
        })
            .catch(function () {
            setSidebarBodyLoader(false);
            setMobileFieldError("Invalid PAN/PEKRN, Mobile/Email combination");
        });
    };
    var getMfCenterDataToProcced = function () {
        setSidebarBodyLoader(true);
        setIsReadyToProceed(false);
        getMfCenterData({
            id: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.id,
            reqId: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.reqId,
            otpRef: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.otpRef,
            userSubjectReference: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.userSubjectReference,
            clientRefNo: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.clientRefNo,
            enteredOtp: otp,
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
        })
            .then(function (resp) {
            var _a, _b, _c, _d, _e;
            if ((resp === null || resp === void 0 ? void 0 : resp.data) && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isSuccess))
                setCurrentScreen(EScreenState.SYNC_SUCCESS);
            else if (((_c = (_b = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) === "406") {
                setIsOtpError((_e = (_d = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.message);
                setIsReadyToProceed(false);
            }
            else
                setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        })
            .catch(function (error) {
            setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        });
    };
    var getArnFiltersDetails = function () {
        getArnFiltersData({
            search_text: EFilterValues.CLIENT_TIER,
        })
            .then(function (resp) {
            setFilterData(resp === null || resp === void 0 ? void 0 : resp.data);
        })
            .catch(function (err) { });
    };
    useEffect(function () {
        getAllClientTableData();
        getArnFiltersDetails();
    }, []);
    return (React.createElement("div", { className: "all-clients-tab-content" },
        React.createElement("span", { className: "DMSansBold_25_700 txt-midnight-blue" }, "All Clients"),
        React.createElement("div", { className: "trasfer-in-logo" },
            React.createElement("img", { src: TransferInImg, alt: "trasfer-in-details" })),
        React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "all-clients-search-pannel", searchBarParentClassName: "w-400", placeholder: "Search by Client Name/UCC/PAN...", applySearchedFilters: function (e) {
                setSearchText(e);
                getAllClientTableData({ searchValue: e });
            }, isShowPopup: isShowFilterPopup, setIsShowPopup: setIsShowFilterPopup, delay: 400, autoComplete: "off", filterComponentInsidePopup: React.createElement(VerticalFilterTabs, { parentClassName: "all-clients-filter-popup", tabsList: allClientFilterTabs, applyBtnCallback: function () {
                    var _a, _b;
                    setFinalFilterState(currentFilterState);
                    getAllClientTableData({
                        clientTierId: ((_b = (_a = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.clientTier) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.Id; })) === null || _b === void 0 ? void 0 : _b.filter(function (id) { return id != null && id !== undefined; }).join(",")) || "",
                    });
                    setIsShowFilterPopup(false);
                }, clearAllBtnCallback: function () {
                    setCurrentFilterState({ clientTier: [], investmentValue: [] });
                    setFinalFilterState({ clientTier: [], investmentValue: [] });
                    getAllClientTableData({ clientTierId: "" });
                    setIsShowFilterPopup(false);
                }, cancelBtnCallback: function () {
                    setIsShowFilterPopup(false);
                }, handleTabChange: function () { } }) }),
        tableLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 5, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-2" })),
        (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 ? (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: tableData, Bodycomponent: GenericTable, rowClassName: "", columns: allClientsTabColumn, parentClassName: "transfer-in-all-clients-tab-table", infinityScroll: true, sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: true, isPageFromParent: true, callbackSorted: function (e) {
                handleCallbackSort(e);
            }, selectedSortVal: sortType.type, selectedSortColumnVal: sortType.sortKey })) : (React.createElement("div", { className: "custom-error-state" },
            React.createElement(Errormsg, { image: noResultsFound, msg: "No Client Found" }))),
        openSidebar && (React.createElement(GenericSidebar, { parentClassname: "arn-transfer-all-client-sidebar", blurBackground: true, header: React.createElement(SidebarHeader, { title: "MF Central", description: "Sync MF holdings. Client OTP required.", iconClass: "edel-icon-cloud" }), body: React.createElement(MFCentralSidebarBody, { mobileNumber: mobileNumber, setMobileNumber: setMobileNumber, isShowOtpField: isShowOtpField, setIsShowOtpField: setIsShowOtpField, otp: otp, setOtp: setOtp, otpTimer: otpTimer, setOtpTimer: setOtpTimer, isOtpError: isOtpError, setIsOtpError: setIsOtpError, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, clientInfoToBeSynced: clientInfoToBeSynced, getMfCenterOtpData: getMfCenterOtpData, sidebarBodyLoader: sidebarBodyLoader, inputDisabled: inputDisabled, mobileFieldError: mobileFieldError, setMobileFieldError: setMobileFieldError }), footer: React.createElement(MFCentralSidebarFooter, { isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, setOpenSidebar: setOpenSidebar, getMfCenterDataToProcced: getMfCenterDataToProcced, setOtpTimer: setOtpTimer, setIsShowOtpField: setIsShowOtpField, clientInfoToBeSynced: clientInfoToBeSynced, setInputDisabled: setInputDisabled, setIsOtpError: setIsOtpError }), openKey: openSidebar, setOpenKey: function (e) {
                if (e === false) {
                    setOpenSidebar(e);
                    setCurrentScreen(EScreenState.GENERATE_OTP);
                    setIsReadyToProceed(false);
                    setIsShowOtpField(false);
                    setOtpTimer(false);
                    setInputDisabled(false);
                    setMobileFieldError("");
                    setIsOtpError("");
                }
            }, arrowClose: true, delay: 10, dontCloseOnOutsideClick: true })),
        (tableActionConfig === null || tableActionConfig === void 0 ? void 0 : tableActionConfig.isShowPopup) && (React.createElement(Overlay, { onHide: function (e) {
                setTableActionConfig(function (prev) { return (__assign(__assign({}, prev), { isShowPopup: false })); });
                setSeletedCheckBox("");
            }, show: true, target: document.getElementById(tableActionConfig.containerId), rootClose: true, rootCloseEvent: "click", placement: "bottom-end", container: document.getElementById(tableActionConfig.containerId) },
            React.createElement(Popover, { id: "popover-contained", className: "sync-now-popup removePopupTooltipArrow", style: { position: "fixed" } },
                React.createElement(Popover.Body, null, syncNowCheckBoxDetails === null || syncNowCheckBoxDetails === void 0 ? void 0 : syncNowCheckBoxDetails.map(function (val, idx) {
                    var _a, _b;
                    return (React.createElement("div", { className: "d-flex gap-2 single-sync ".concat(((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value) === seletedCheckBox && "bg-ghost-white3"), key: idx, onClick: function () {
                            var _a;
                            setSeletedCheckBox((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value);
                            setOpenSidebar(true);
                        } },
                        React.createElement("div", null,
                            React.createElement(RadioButton, { name: "sync-now-radio", list: val === null || val === void 0 ? void 0 : val.item, key: idx, selected: seletedCheckBox, onChange: function (e) {
                                    setSeletedCheckBox(e.target.value);
                                    setOpenSidebar(true);
                                } })),
                        React.createElement("div", { className: "d-flex flex-column gap-2" },
                            React.createElement("span", { className: "DMSanN_14_400 txt-purpleFog" }, (_b = val === null || val === void 0 ? void 0 : val.item) === null || _b === void 0 ? void 0 : _b.display),
                            React.createElement("span", { className: "DMsanR_12_300 txt_manatee" }, val === null || val === void 0 ? void 0 : val.desc))));
                })))))));
};
export default AllClientsTab;
